<template>
  <div>
    <table class="table table-striped jambo_table bulk_action">
      <thead>
        <tr class="headings">
          <th class="column-title word_center">隊編/呼號</th>
          <th class="column-title word_center">姓名</th>
          <th class="column-title word_center">司機電話</th>
          <th class="column-title word_center">司機備註</th>
          <th class="column-title word_center">目前車輛狀態</th>
          <th class="column-title word_center">是否有搶單</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(driver, index) in driverStatusList">
          <tr class="pointer" style="text-align: center">
            <td class=" ">{{ driver.driverInfo.callNumber }}</td>
            <td class=" ">{{ driver.driverInfo.name }}</td>
            <td class=" ">{{ driver.driverInfo.phone }}</td>
            <th class=" ">{{ driver.driverInfo.note }}</th>
            <td class=" ">
              {{
                driver.driverInfo.carStatus === 1
                  ? '空車'
                  : driver.driverInfo.carStatus === 0
                    ? '休息'
                    : driver.driverInfo.carStatus === 4
                      ? '排班'
                      : driver.driverInfo.carStatus === 3
                        ? '已載客'
                        : '錯誤'
              }}
            </td>
            <td class=" ">
              {{
                driver.driverInfo.driverStatus === 1
                  ? '搶單'
                  : driver.driverInfo.driverStatus === 2
                    ? '拒絕'
                    : '閒置(沒有做任何事)'
              }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ['driverStatusList'],
}
</script>
<style scoped>
.class-a {
  background-color: rgb(249, 112, 112);
  color: red;
}
.class-b {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/hailing/SearchTaxiResult.vue